<template>
    <div class="container">
        <div class="img">┭┮﹏┭┮</div>
        <div>
            404页面走丟了。。。
        </div>
    </div>
</template>
<script>
    export default {
        name: "page404",
        data() {
            return {}
        }
    }
</script>
<style scoped>
    .container {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        font-weight: bold;
        font-size: 40px;
        position: fixed;
        width: 100%;
        height: 100%;
        /*background: url("../assets/bg@2x.png") no-repeat center;*/
        /*background-size: cover;*/
    }

    .container > .img {
        width: 40%;
        max-width: 200px;
        margin-bottom: 20px;
    }
</style>
